import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import Modal from "src/components/Common/UI/Modal/Modal";
import CreateLineType from "./CreateLineType";
import { useLineTypesDataViewLogic } from "./hooks/useLineTypesDataViewLogic";
import EditLineType from "./EditLineType";
import DeleteLineType from "./DeleteLineType";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";


const LineTypesDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent
  } = useLineTypesDataViewLogic();

  const addLineTypeButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέo Είδος Γραμμής`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} />
  );

  return (
    <>
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={false}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No LineTypes yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addLineTypeButton}
                textPosition="center"
            />
          </>
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          >
            {modalEvent.action === "create" && <CreateLineType handleCloseModal={closeActionModal}/> }
            {modalEvent.action === "edit" && <EditLineType handleCloseModal={closeActionModal} lineTypeId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
            {modalEvent.action === "delete" && <DeleteLineType handleCloseModal={closeActionModal} lineTypeId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default LineTypesDataView;

